export default (theme) => ({
    root: {
        display: 'flex',
        flexFlow: 'column nowrap',
        '[class*="HoiPoi__QuickFilters__popoverCustomWide"] & [class*="hoi-poi-select__menu "]': {
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: `${theme.effects.boxShadow} !important`,
        },
    },
    row: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        gap: 8,
        paddingBottom: 8,
    },
    divider: {
        marginTop: 8,
        marginBottom: 16,
    },
    sep: {
        display: 'inline-block',
        width: 10,
        textAlign: 'center',
    },
    badgeWrap: {
        width: 'calc(100% - 132px)',
    },
    inputWrap: {
        flexBasis: 80,
        '& [class*="inputWrapper"]': {
            padding: 0,
        },
    },
});
